export const projects = [
  {
    id: "1",
    title: "FreshEdge",
    description:
      "Edge-based proactive meal planning assistant that suggests recipes from fridge contents.",
    technologies: [
      "Python",
      "Kotlin",
      "ChromaDB",
      "Ollama",
      "Firebase",
      "Raspberry Pi",
    ],
    githubLink: "https://github.com/msvish/FreshEdge",
    image: "FreshEdge",
    live: true,
    demoLink: "https://youtu.be/IH8HtX7pLWs",
    features: [
      "Raspberry Pi scheduler triggers 1 hour before each meal automatically",
      "LLaVA vision model identifies fridge ingredients from a camera snapshot",
      "RAG pipeline retrieves best-matching recipes from 996 Food.com recipes",
      "Phi-3 Mini generates a personalized meal suggestion on-device",
      "Firebase Cloud Messaging delivers suggestion as a push notification",
      "Android companion app for setting meal times and viewing history",
      "Entire AI pipeline runs locally — zero cloud cost",
    ],
  },
  {
    id: "2",
    title: "Pivot Point Voice QA Agent",
    description:
      "Autonomous voice AI agent that places real phone calls to test and audit a clinic's conversational AI system.",
    technologies: [
      "Python",
      "LiveKit Agents",
      "Deepgram",
      "OpenAI",
      "Cartesia",
      "Twilio",
    ],
    githubLink: "https://github.com/msvish/pgai-voice-bot",
    image: "VoiceQA",
    live: true,
    demoLink: "https://youtu.be/Lt5NfYjUy3Q",
    features: [
      "Fully automated caller-simulator built with LiveKit's STT-LLM-TTS pipeline",
      "Places real outbound calls over a live SIP/Twilio telephony connection",
      "Simulates diverse patient personas: booking, rescheduling, cancellations, refills, insurance updates",
      "Found and documented a important patient-data verification vulnerabilities",
      "Custom call-ending logic that waits for full audio playout before disconnecting",
    ],
  },
  {
    id: "3",
    title: "EVA (Email Voice Assistant)",
    description: "Voice-controlled email management for visually impaired.",
    technologies: ["Javascript", "Html", "Css"],
    githubLink: "https://github.com/msvish/EVA",
    image: "Eva",
    live: true,
    demoLink: "https://vimeo.com/714883872",
    features: [
      "Web-based Chrome extension",
      "Designed for visually impaired users",
      "Utilizes Interactive Voice Response (IVR)",
      "Voice-controlled mail account management",
      "Supports reading, sending, and other mail operations",
      "Voice prompts for user actions",
      "User responds to voice commands",
    ],
  },
  {
    id: "4",
    title: "Smart Door Authentication System",
    description:
      "Cloud-native facial recognition security system using AWS serverless architecture.",
    technologies: [
      "AWS Lambda",
      "Python",
      "Amazon Rekognition",
      "Kinesis Video Streams",
      "DynamoDB",
      "Docker",
      "API Gateway",
      "Amazon SES",
    ],
    githubLink:
      "https://drive.google.com/file/d/17Z83CdPG5KlOUNJVQbLY9MruPsKDneQe/view?usp=drive_link",
    image: "SmartDoor",
    live: false,
    demoLink: "https://demo.example.com",
    features: [
      "Real-time facial recognition using Amazon Rekognition",
      "Serverless event-driven architecture with AWS Lambda",
      "Video stream processing via Kinesis Video Streams",
      "Automated OTP generation and email delivery (Amazon SES)",
      "Unknown visitor alert system with photo approval workflow",
      "DynamoDB TTL for automatic passcode expiration",
      "Docker-based video simulation for testing",
      "Cooldown mechanism to prevent notification spam",
    ],
  },
  {
    id: "5",
    title: "Health Dashboard",
    description:
      "Modern healthcare dashboard UI showcasing patient monitoring interface design.",
    technologies: ["React", "JavaScript", "Chart.js", "Vite", "CSS"],
    githubLink: "https://github.com/msvish/health-dashboard",
    image: "HealthCareDashboard",
    live: true,
    demoLink: "https://msvish.github.io/health-dashboard",
    features: [
      "Static frontend UI replicating professional medical dashboard design",
      "Patient vital signs display (heart rate, temperature, respiratory rate)",
      "Data visualization using Chart.js for health metrics",
      "Clean patient profile layout with demographic information",
      "Appointment calendar and scheduling interface mockup",
      "Medical records and diagnosis history UI components",
      "Responsive design optimized for healthcare professionals",
      "Modern healthcare UX with intuitive information architecture",
    ],
  },
  {
    id: "6",
    title: "Pizza Maker",
    description: "Customizable pizza app with drag-and-drop.",
    technologies: ["Javascript", "React", "MaterialUI"],
    githubLink: "https://github.com/msvish/PizzaMaker",
    image: "Pizzamaker",
    live: true,
    demoLink: "https://sage-squirrel-e59697.netlify.app/",
    features: [
      "Horizontal scrolling",
      "Drag and drop",
      "Image overlapping",
      "Material design react components",
    ],
  },
  {
    id: "7",
    title: "Hostel Management",
    description: "Streamlined student and hostel management system.",
    technologies: ["Java", "Mysql", "Html", "Css"],
    githubLink: "https://github.com/msvish/HostelManagement",
    image: "Hostelmanagement",
    live: false,
    demoLink: "https://demo.example.com",
    features: [
      "UI Interface for Signing Up and managing students",
      "Implementation to connect Frontend to MySQL using MySQL connector ",
      "Trigger Implementation",
      "Aggregator Implementation",
    ],
  },
  {
    id: "8",
    title: "Co-Ordinates Finder",
    description: "Get coordinates for any global address.",
    technologies: ["Python", "Flask"],
    githubLink: "https://github.com/msvish/CoOrdinatesFinder",
    image: "Coordinates",
    live: false,
    demoLink: "https://demo.example.com",
    features: ["API Development", "Google Maps Geocoding API Integration"],
  },
  {
    id: "9",
    title: "Nilconnect",
    description: "A video conferencing platform",
    technologies: [
      "Javascript",
      "React",
      "Html",
      "Css",
      "MaterialUI",
      "Jitsi",
      "Firebase",
    ],
    githubLink: "https://github.com/msvish/Nilconnect",
    image: "Nilconnect",
    live: false,
    demoLink: "https://demo.example.com",
    features: [
      "Google SSO Implementation",
      "Jitsi Meet Integration",
      "Real-Time User Chat",
    ],
  },
  {
    id: "10",
    title: "Mass Mail Dispenser",
    description: "Mass mail via CSV with invalid email sorting.",
    technologies: ["Html", "Python", "Flask", "Smtplib"],
    githubLink: "https://github.com/msvish/MassMailDispenser",
    image: "Massmaildispenser",
    live: false,
    demoLink: "https://demo.example.com",
    features: [
      "Basic interface for entering information",
      "Validates email addresses",
      "Allows CSV file upload",
      "Displays invalid email addresses",
      "Api Integration",
    ],
  },
];
